<template>
  <div class="loading">
    <div class="loading__container flexCenter">
      <div class="loading__bigCircle flexCenter">
        <div class="loading__smallCircle flexCenter">
          <div class="loading__number">{{ timer }}</div>
        </div>
      </div>
      <svg width="1px" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="line">
        <rect width="1" height="100%" fill="#979797"></rect>
      </svg>
      <svg width="100%" height="1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="line">
        <rect width="100%" height="1" fill="#979797"></rect>
      </svg>
      <svg width="3840px" height="3840px" class="chart">
        <circle r="960" cx="1920" cy="1920" class="pie"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      timer: 0
    }
  },
  mounted () {
    let loader = setInterval(() => {
      if (this.$parent.loading === false) {
        this.timer = 100
        this.$parent.load = false
        this.$parent.afterLoadingIntro()
        clearInterval(loader)
      }
    }, 750)
  }
}
</script>

<style lang="scss" scoped>
// responsive
$phone:640px;
$tablet: 768px;
$desktop: 1024px;

.loading
{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  background-image:url("../../../static/noise.png");
  background-repeat: none;
  background-color: #000;
  z-index: 1000;

  @media screen and (max-width: $phone) and (orientation: portrait) {
    height: 100%;
  }

  .loading__container
  {
    width: 100%;
    height: 100%;

    .loading__bigCircle
    {
      width: 640px;
      height: 640px;
      border-radius: 1000px;
      border: 1px solid #ffffff;
      position: relative;
      z-index: 3;

      @media screen and (max-width: $phone) and (orientation: portrait) {
        width: 320px;
        height: 320px;
      }

      .loading__smallCircle
      {
        width: 600px;
        height: 600px;
        border-radius: 1000px;
        border: 1px solid #ffffff;

        @media screen and (max-width: $phone) and (orientation: portrait) {
          width: 300px;
          height: 300px;
        }

        .loading__number
        {
          font-family: "DIN Pro";
          font-size: 240px;
          color: #ffffff;

          @media screen and (max-width: $phone) and (orientation: portrait) {
            font-size: 120px;
          }
        }
      }
    }

    .line
    {
      position: absolute;
      z-index: 2;
    }

    .chart
    {
      position: absolute;
      transform: rotate(-90deg);
      border-radius: 50%;
      display: block;

      circle
      {
        fill: transparent;
        stroke:rgba(255,255,255,0.10);
        stroke-width: 1920;
        stroke-dasharray: 6030 6030;
        animation: pieAnimation 0.75s linear infinite;

        @keyframes pieAnimation {
          0% {
            stroke-dasharray: 0 6030;
          }
          100% {
            stroke-dasharray: 6030 6030;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/Loading.vue